__turbopack_context__.v({
  "fade-in": "BulletList-module-scss-module__uowCJW__fade-in",
  "item": "BulletList-module-scss-module__uowCJW__item",
  "list": "BulletList-module-scss-module__uowCJW__list",
  "listColumns": "BulletList-module-scss-module__uowCJW__listColumns",
  "no-transform": "BulletList-module-scss-module__uowCJW__no-transform",
  "rotate": "BulletList-module-scss-module__uowCJW__rotate",
});
